import { render, staticRenderFns } from "./IMPrice.vue?vue&type=template&id=63d2260c&"
import script from "./IMPrice.vue?vue&type=script&lang=js&"
export * from "./IMPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports